import { gql } from '@apollo/client';

import { ActivePracticeSession } from '../../types';
import { ActivePracticeSessionFragment } from '../fragments';

export interface AnswerPracticeSessionExerciseMutationVariables {
  courseId: string;
  practiceSessionId: string;
  input: {
    exercise: string;
    selectedOptions: Record<string, any>;
  };
}

export interface AnswerPracticeSessionExerciseMutationResult {
  activePracticeSession: ActivePracticeSession;
}

export const answerPracticeSessionExerciseMutation = gql`
  mutation AnswerPracticeSessionExerciseMutation(
    $courseId: String!
    $practiceSessionId: String!
    $input: AnswerPracticeSessionExerciseMutationInput!
  ) {
    activePracticeSession(courseId: $courseId, practiceSessionId: $practiceSessionId, input: $input)
      @rest(type: "ActivePracticeSession", path: "courses/{args.courseId}/practice/{args.practiceSessionId}/send-exercise-answer", method: "PUT") {
      ...ActivePracticeSession
    }
  }
  ${ActivePracticeSessionFragment}
`;
